import { createContext, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoEffectOptions } from 'contexts/LiveKitDevicesStateContext/LiveKitDevicesStateContext';

import { Theme } from './types';

export const ThemeContext = createContext<Theme | null>(null);

const resolveLocalizedLink = (link: string | Record<string, string> | undefined, language: string): string => {
  if (!link) return '';
  if (typeof link === 'string') return link;

  return link[language] ?? link.en ?? '';
};

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const { i18n } = useTranslation();
  const cfg = window.__APP_CONFIG__ ?? {};
  const language = i18n.resolvedLanguage ?? i18n.language ?? 'en';

  const themeValue: Theme = {
    logo: { src: cfg.logoSrc ?? '' },
    logoContrast: cfg.logoContrastSrc ? { src: cfg.logoContrastSrc } : undefined,
    appName: cfg.appName ?? '',
    supportEmail: cfg.supportEmail ?? '',
    appDomain: cfg.appDomain ?? '',
    authenticationMeetingImages: {
      browser: cfg.authBrowserImageSrc ?? '',
      mobile: cfg.authMobileImageSrc ?? '',
    },
    privacyPolicyLink: resolveLocalizedLink(cfg.privacyPolicyLink, language),
    termsOfServiceLink: resolveLocalizedLink(cfg.termsOfServiceLink, language),
    helpLink: resolveLocalizedLink(cfg.helpLink, language),
    videoBackgroundOptions: cfg.videoBackgrounds?.map(({ id, path }) => ({
      id: id as VideoEffectOptions,
      path,
    })),
  };

  return (
    <ThemeContext.Provider value={themeValue}>
      <div className="h-full w-full dark">{children}</div>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
